const ProgressBar = ({ value }) => {
  return (
    <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
      <div
        className="h-full bg-green-700 rounded-full"
        style={{ width: `${value}%` }}
      />
    </div>
  );
};

export default ProgressBar;
